var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10081_6216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8327 -5.33325H12.166C2.50103 -5.33325 -5.33398 2.50176 -5.33398 12.1667V51.8334C-5.33398 61.4984 2.50103 69.3334 12.166 69.3334H51.8327C61.4977 69.3334 69.3327 61.4984 69.3327 51.8334V12.1667C69.3327 2.50176 61.4977 -5.33325 51.8327 -5.33325Z",
    fill: "url(#paint0_radial_10081_6216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8327 -5.33325H12.166C2.50103 -5.33325 -5.33398 2.50176 -5.33398 12.1667V51.8334C-5.33398 61.4984 2.50103 69.3334 12.166 69.3334H51.8327C61.4977 69.3334 69.3327 61.4984 69.3327 51.8334V12.1667C69.3327 2.50176 61.4977 -5.33325 51.8327 -5.33325Z",
    fill: "url(#paint1_radial_10081_6216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0054 25.8467C28.5994 25.8467 25.8521 28.594 25.8521 32C25.8521 35.406 28.5994 38.1533 32.0054 38.1533C35.4114 38.1533 38.1586 35.406 38.1586 32C38.1586 28.594 35.4114 25.8467 32.0054 25.8467ZM32.0054 36.0004C29.8043 36.0004 28.0049 34.2064 28.0049 32C28.0049 29.7936 29.7989 27.9996 32.0054 27.9996C34.2118 27.9996 36.0058 29.7936 36.0058 32C36.0058 34.2064 34.2064 36.0004 32.0054 36.0004V36.0004ZM39.8456 25.595C39.8456 26.3929 39.2029 27.0302 38.4104 27.0302C37.6124 27.0302 36.9751 26.3876 36.9751 25.595C36.9751 24.8024 37.6178 24.1598 38.4104 24.1598C39.2029 24.1598 39.8456 24.8024 39.8456 25.595ZM43.921 27.0517C43.83 25.1291 43.3908 23.4261 41.9824 22.023C40.5793 20.6199 38.8763 20.1807 36.9537 20.0843C34.9722 19.9719 29.0331 19.9719 27.0517 20.0843C25.1344 20.1754 23.4314 20.6145 22.023 22.0176C20.6145 23.4207 20.1807 25.1237 20.0843 27.0463C19.9719 29.0278 19.9719 34.9669 20.0843 36.9483C20.1754 38.8709 20.6145 40.5739 22.023 41.977C23.4314 43.3801 25.1291 43.8193 27.0517 43.9156C29.0331 44.0281 34.9722 44.0281 36.9537 43.9156C38.8763 43.8246 40.5793 43.3855 41.9824 41.977C43.3855 40.5739 43.8246 38.8709 43.921 36.9483C44.0335 34.9669 44.0335 29.0331 43.921 27.0517V27.0517ZM41.3611 39.0744C40.9434 40.1241 40.1348 40.9327 39.0798 41.3558C37.4999 41.9824 33.7512 41.8378 32.0054 41.8378C30.2595 41.8378 26.5054 41.977 24.9309 41.3558C23.8813 40.9381 23.0726 40.1294 22.6496 39.0744C22.023 37.4946 22.1676 33.7458 22.1676 32C22.1676 30.2542 22.0283 26.5001 22.6496 24.9256C23.0673 23.8759 23.8759 23.0673 24.9309 22.6442C26.5108 22.0176 30.2595 22.1622 32.0054 22.1622C33.7512 22.1622 37.5053 22.023 39.0798 22.6442C40.1294 23.0619 40.9381 23.8706 41.3611 24.9256C41.9877 26.5054 41.8431 30.2542 41.8431 32C41.8431 33.7458 41.9877 37.4999 41.3611 39.0744Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10081_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4993 75.0842) rotate(-90) scale(74.0002 68.826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10081_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17.8409 0.0453722) rotate(78.681) scale(33.0785 136.351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10081_6216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramToken);
export default __webpack_public_path__ + "static/media/instagram-token.f3b81993b88fa5fcc9ba447f0fd51b6a.svg";
export { ForwardRef as ReactComponent };